import React, { useEffect } from "react";
import ISupplierModel from "../../../models/ISupplierModel";
import OwButton from "../OwButton/OwButton";
import OwLabel from "../OwLabel/OwLabel";
import Modal from "react-modal";
import OwTitle from "../OwTitle/OwTitle";
import "./OwToggle.scss";

type Props = {
    fn: (e: any) => void;
    name: string;
    label: string;
    saveBtn?: boolean;
    disabled?: boolean;
    showDisableConfirm?: boolean;
    active: boolean;
    isSupplierVendorOverride?: boolean;
    supplierModel?: ISupplierModel;
    labelOnRight?: boolean;
    wrapperClassName?: string;
    disableTranslation?: boolean;
};

const OwToggle = (props: Props) => {
    const [active, setActive] = React.useState(props.active);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const customStyles = { overlay: { zIndex: 10 } };

    const getContainerClass = () => {
        let _containerClass = "me-2 pointer";

        if (props.disabled) {
            _containerClass = "me-2";
        }

        if (props.labelOnRight) {
            _containerClass = "ms-2 pointer";
        }

        return _containerClass;
    };

    const getWrapperClass = () => {
        let _wrapperClass = "d-inline-flex align-items-center wrapper";

        if (props.disabled) {
            _wrapperClass += " disabled";
        }

        if (props.wrapperClassName) {
            _wrapperClass += " " + props.wrapperClassName;
        }

        return _wrapperClass;
    };

    const containerClass = getContainerClass();

    const wrapperClass = getWrapperClass();

    const completeConfirm = () => {
        const e = {
            target: {
                value: active,
                name: props.name,
            },
        };

        props.fn(e);
    };

    useEffect(() => {
        // this helps also to prevent on initial load it 'toggling' when the value hasn't changed.
        if (props.active !== active) {
            completeConfirm();
        }
    }, [active]);

    useEffect(() => {
        if (props.active !== active) {
            setActive(props.active);
        }
    }, [props.active]);

    const toggleActive = () => {
        if (props.disabled) {
            return null;
        }

        if (active && props.showDisableConfirm) {
            setIsModalOpen(true);
        } else {
            setActive(!active);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const confirmModal = () => {
        setIsModalOpen(false);
        setActive(!active);
    };

    return (
        <div className="OwToggle">
            <div className={wrapperClass}>
                <div className={"d-inline-flex align-items-center pointer"} onClick={toggleActive}>
                    {props.label && !props.labelOnRight ? (
                        <OwLabel
                            title={props.label}
                            className={containerClass}
                            isSupplierVendorOverride={props.isSupplierVendorOverride}
                            supplierModel={props.supplierModel}
                            skipTranslate={props.disableTranslation}
                        />
                    ) : null}
                    <div className={"main-container " + (active ? "active" : "")}>
                        <div className={"toggle-button"}></div>
                    </div>
                    {props.label && props.labelOnRight ? (
                        <OwLabel
                            title={props.label}
                            className={containerClass}
                            isSupplierVendorOverride={props.isSupplierVendorOverride}
                            supplierModel={props.supplierModel}
                            skipTranslate={props.disableTranslation}
                        />
                    ) : null}
                </div>
            </div>

            {props.showDisableConfirm ? (
                <Modal isOpen={isModalOpen} style={customStyles} className={"modalContentClass"} overlayClassName={"modalOverlayClass"}>
                    <div className={"p-2"}>
                        <div className={"text-end"}>
                            <OwButton className={"btn-danger"} fn={closeModal} centerIconClass={"fas fa-times"} />
                        </div>
                        <OwTitle className={"text-center"} title={"confirm_disable"} />
                        <div className={"text-center"}>
                            <OwLabel title={"please_confirm_disable_dialog"} className={"mt-2"} />
                        </div>

                        <div className={"d-flex justify-content-center"}>
                            <OwButton title={"confirm"} className={"btn-primary me-2"} fn={confirmModal} />
                            <OwButton title={"cancel"} className={"btn-danger"} fn={closeModal} />
                        </div>
                    </div>
                </Modal>
            ) : null}
        </div>
    );
};

export default OwToggle;
